import { config } from './main.js';

export {
    init,
    ctx,
    clear,
}

let ctx;

function init() {
    const canvas = document.querySelector('canvas');
    ctx = canvas.getContext('2d');

    canvas.width = config.width * devicePixelRatio;
    canvas.height = config.height * devicePixelRatio;

    ctx.scale(devicePixelRatio, devicePixelRatio);

    if (DEVMODE) console.log(`Canvas initialized with DPR: ${devicePixelRatio} Size: ${canvas.width}/${canvas.height}`);
}

function clear () {
    ctx.clearRect(0, 0, config.width, config.height);
}